// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SubReportLink.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component } from 'react';

import connect from 'share/enhancers/Izenda.Connect';
import Dimensions from 'share/components/hoc/Izenda.Dimensions';
import ReportPartFrontSideViewer from '../../ReportPartFrontSideViewer/Izenda.ReportPartFrontSideViewer';
import ReportDesignerConstants from 'logic/data/Izenda.ReportDesignerConstants';
import ReportPartUtils from 'share/utils/Izenda.ReportPartUtils';
import SubReportUtils from 'share/utils/Izenda.SubReportUtils';
import embededReportUtils from 'share/utils/Izenda.EmbededReportUtils';
import ReportPartCommonActionPopup from '../Izenda.ReportPartCommonActionPopup';
import classnames from 'classnames';
import PrintingUtils from 'share/utils/Izenda.PrintingUtils';
// $FlowFixMe
import { invoke, omit, get, isUndefined, forEach, isEmpty } from 'lodash/fp';

const EmbededReport = Dimensions(
  class EmbeddedSubReport extends Component {

    componentDidUpdate(prevProps) {
      const { width, height } = this.props;
      if (width !== prevProps.width || height !== prevProps.height) {
        invoke('afterRenderCallBack', this.props);
      }
    }

    render() {
      const {
        props,
        props: { width }
      } = this;
      const containerWidth = isUndefined(props.containerWidth) ? width : props.containerWidth || 0;
      const omitProps = ['width', 'height', 'containerWidth'];

      return (
        <div>
          <ReportPartFrontSideViewer containerWidth={containerWidth} {...omit(omitProps, props)} embededReportPart />
        </div>
      );
    }
  }
);

const SubReportLink = props => {
  const { reportPart, rawRecord, fieldElement, linkTitleText } = props;

  const elementProperties = get('properties', fieldElement);

  const subReport = get('subReport', elementProperties);
  const customURL = get('customURL', elementProperties);
  const embeddedJavascript = get('embeddedJavascript', elementProperties);
  const numberOfPointActions = get('numberOfPointActions', fieldElement);

  const fieldConfig = {
    subReport,
    customURL,
    embeddedJavascript,
    numberOfPointActions,
    fieldElement
  };

  if (subReport && subReport.style === ReportDesignerConstants.DRILL_DOWN_STYLE_OPTION_VALUES.embedded) {
    return applySubReportEmbedded();
  } else {
    let icon;
    let isLink = false;

    if (numberOfPointActions === 1) {
      subReport &&
        subReport.selectedReport &&
        (subReport.viewSettingByLink ? (isLink = true) : (icon = subReport.selectedIconValue.icon));
      customURL &&
        customURL.url &&
        (customURL.viewSettingByLink ? (isLink = true) : (icon = customURL.selectedIconValue.icon));
      embeddedJavascript &&
        embeddedJavascript.script &&
        (embeddedJavascript.viewSettingByLink ? (isLink = true) : (icon = embeddedJavascript.selectedIconValue.icon));
    } else if (numberOfPointActions > 1) {
      isLink = true;
    }

    let titleText = (customURL && customURL.url) || '';
    if (linkTitleText) {
      titleText = linkTitleText;
    }

    if (isLink) {
      return (
        <a title={titleText}>
          <span className='u_textLink' onClick={hyperlinkAction}>
            {props.children}
          </span>
        </a>
      );
    }
    return (
      <div>
        <a title={titleText}>
          <span className={classnames('u_textLink', icon)} onClick={hyperlinkAction} />
        </a>
        {props.children}
      </div>
    );
  }

  function applySubReportEmbedded() {
    const filters = SubReportUtils.buildFilterDataCommon(rawRecord, subReport.mappingFields, reportPart);

    if (!filters.success) {
      return <section>{filters.errors}</section>;
    }
    const overideFilterValue = props.getFilterInfoForSubReport();
    const subReportFilter = SubReportUtils.buildFilterDataForEmbededReportPart(
      filters.fieldMapping,
      reportPart,
      subReport,
      overideFilterValue
    );

    // Insert CustomURLLink/embeddedJavascriptLink beside subReport embedded
    const customUrlIcon = get('url', customURL) && get('selectedIconValue.icon', customURL);
    const embeddedJavascriptIcon =
      get('script', embeddedJavascript) && get('selectedIconValue.icon', embeddedJavascript);

    const listEmbededReportPart = embededReportUtils.readEmbededReportDef(reportPart, fieldElement);

    const renderListeners = [];

    /**
     * Build child render promises
     */
    function buildChildPromises() {
      forEach(part => {
        PrintingUtils.pushRenderListener(renderListeners, part.id);
      }, listEmbededReportPart);
    }

    /**
     * Publish finished render event.
     */
    function publishFinishedRender() {
      props.printingMode &&
        PrintingUtils.publishFinishedRender(renderListeners, () => {
          props.finishedRender && props.finishedRender();
        });
    }

    buildChildPromises();
    publishFinishedRender();

    return (
      <section>
        {customUrlIcon && <span className={customUrlIcon} onClick={openCustomURL} />}
        {embeddedJavascriptIcon && <span className={embeddedJavascriptIcon} onClick={performEmbeddedJavascript} />}
        {isEmpty(listEmbededReportPart)
          ? props.children
          : listEmbededReportPart.map(reportPartDef => (
              <EmbededReport
                key={reportPartDef.id}
                reportPartDef={reportPartDef}
                subReportFilter={subReportFilter}
                printingMode={props.printingMode}
                containerWidth={props.containerWidth}
                finishedRender={PrintingUtils.getFinishedRenderPromiseById(renderListeners, reportPartDef.id)}
                afterRenderCallBack={props.afterRenderCallBack}
                ignoreCache={props.ignoreCache}
              />
            ))}
      </section>
    );
  }

  function hyperlinkAction() {
    ReportPartUtils.openHyperlinkAction(props, fieldConfig, rawRecord, ReportPartCommonActionPopup);
  }

  function openCustomURL() {
    ReportPartUtils.openCustomURL(props, customURL, rawRecord);
  }

  function performEmbeddedJavascript() {
    ReportPartUtils.performEmbeddedJavascript(props, embeddedJavascript, rawRecord);
  }
};

export default connect()(SubReportLink);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartGrid/Izenda.SubReportLink.js